import rootPackage from '../../package.json';

export const SOFTWARE_BASELINE_VERSION = rootPackage.version;
export const BASELINE_SOFTWARE_VERSION = SOFTWARE_BASELINE_VERSION;
